import React from 'react'
import Logo from '../logo.svg'
import { NavLink } from 'react-router-dom'

const navigation = [
  { name: 'Home', href: '/' },
  { name: 'Our Staff', href: '/#staff' },
  { name: 'Camp Details', href: '/#details' },
  { name: 'Pricing', href: '/#pricing' },
]

const Navbar = () => {
  // const [mobileMenuOpen, setMobileMenuOpen] = useState(false)
  const navigationMenu = navigation.map((element, index) => {
    return (
      <NavLink key={index} to={element.href} reloadDocument>{element.name}</NavLink>
    )})
  
  return (
    <nav className="flex sticky top-0 justify-between z-50 items-center bg-secondary-900/30 container-padding py-2 shadow-lg backdrop-blur-md border-b border-gray-800">
      <div>
        <img src={Logo} alt="coach-alliance" className="w-12"/>
      </div>
      
      <div className="lg:flex gap-16 hidden">
        {navigationMenu}
      </div>
      
      <div className="lg:flex gap-4 hidden lg:items-center">
        <a className="hover:text-primary-500" href="#details">Learn More</a>
        <a className="btn-primary py-1 px-12 rounded-md" href="#pricing">Register</a>
      </div>
    </nav>
  )
}

export default Navbar